// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__jlHvv","bigColWidth":"Table_bigColWidth__38p4H","biggerColWidth":"Table_biggerColWidth__Ka9xw","row":"Table_row__1zeYH","col":"Table_col__yIGdl"};